import {
    Box,
    Button,
    Grid,
} from "@mui/material";
import './PrivateLayout.scss';
import {NavLink} from "react-router-dom";
import {ReactNode, useState} from "react";
import AppHeader from "./Header/AppHeader";
import InboxConfirming from "./Inbox/InboxConfirming";

export default function PrivateLayout(props: {element: ReactNode}) {
    const [showed, setShowed] = useState(false)

    function menuWrapperClassName() {
        if(showed){
            return "menuWrapper showed";
        }
        return "menuWrapper";
    }

    return (
        <div>
            <InboxConfirming />
            <AppHeader onMenuToggle={() => setShowed(!showed)}/>
            <Button className="MenuMobileButton" fullWidth onClick={() => setShowed(!showed)}>Menu</Button>
            <Grid container className="privateWrapper">
                <Grid item xs={12} md={4} lg={3} className={menuWrapperClassName()}>
                    <Box className="menu">
                        <NavLink to="/" ><span>Aktualne dane podmiotu</span></NavLink>
                        <NavLink reloadDocument to="/nadaj-pismo"><span>Nadaj pismo</span></NavLink>
                        <NavLink reloadDocument to="/skrzynka-odbiorcza"><span>Skrzynka odbiorcza</span></NavLink>
                        <NavLink to="/lista-pism"><span>Wygenerowane pisma</span></NavLink>
                        <NavLink reloadDocument to="/sprawdz-pismo"><span>Sprawdź sygnaturę pisma</span></NavLink>
                        <NavLink to="/raporty"><span>Raporty</span></NavLink>
                        <NavLink to="/subskrypcje" ><span>Abonament</span></NavLink>
                    </Box>
                </Grid>

                <Grid item  xs={12} md={8} lg={9}>
                    <Box className="privateContentWrapper">
                        {props.element}
                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}
